<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="500"
  >
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <div class="center">
      <nz-select
        nzPlaceHolder="Packer auswählen"
        nzShowSearch
        nzServerSearch
        class="full-width"
        (nzOnSearch)="onSearch($event)"
        [nzLoading]="areUsersLoading"
        [(ngModel)]="selectedUserId"
        [nzDisabled]="isConfirmLoading"
        (ngModelChange)="packerName = null"
        [nzAutoClearSearchValue]="true"
        >
        @for (user of (users$ | async); track user) {
          <nz-option [nzLabel]="user.fullName" [nzValue]="user.id"></nz-option>
        }
      </nz-select>
      <nz-divider nzText="Oder"></nz-divider>
      <input
        type="text"
        nz-input
        [disabled]="isConfirmLoading"
        placeholder="Name des Packers eingeben"
        [(ngModel)]="packerName"
        (ngModelChange)="selectedUserId = null"
        >
      <nz-form-item style="margin-top: 16px; margin-bottom: 0;">
        <nz-form-label>Anzahl</nz-form-label>
        <nz-form-control>
          <nz-input-number [(ngModel)]="quantity" [nzMin]="1" [nzMax]="50" [nzStep]="1"></nz-input-number>
        </nz-form-control>
      </nz-form-item>
    </div>
  </ng-template>


  <ng-template #modalFooter>
    @if (labelKey) {
      <button [hidden]="true" appOpenPdf [key]="labelKey" #openPdfButtonElRef></button>
    }
    <button nz-button nzType="default" (click)="handleCancel()" [disabled]="isLoading">Schließen</button>
    <button
      nz-button
      nzType="primary"
      (click)="handleOk()"
      [nzLoading]="isConfirmLoading"
      [disabled]="isLoading"
    >Drucken</button>
  </ng-template>
</nz-modal>
